// extracted by mini-css-extract-plugin
export default {"wrapper":"Desktop_wrapper__HFaaT","Desktop":"Desktop_Desktop__4Xr0n","distributor":"Desktop_distributor__ni43o","distAnimation":"Desktop_distAnimation__DPLAH"};